export default "__VITE_ASSET__CpeE2SFZ__"